import { render, staticRenderFns } from "./BaseProperties.vue?vue&type=template&id=9445c674&"
import script from "./BaseProperties.vue?vue&type=script&lang=ts&"
export * from "./BaseProperties.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports